 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import ALSOBYPATRICIADIXON from '@/components/alsobypatriciadixon'
 import DEDICATION from '@/components/dedication'
 import EPIGRAPH from '@/components/epigraph'
 import FOREWORD from '@/components/foreword'
 import NOMOREYESTERDAYS from '@/components/nomoreyesterdays'
 import ACHANGEOFPLAN from '@/components/achangeofplan'
 import FROMTHEMOUTHSOFBABES from '@/components/fromthemouthsofbabes'
 import ACHRISTMASTALE from '@/components/achristmastale'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import ANOTEFROMTHEPUBLISHER from '@/components/anotefromthepublisher'
 import LOVEWOMENSCONTEMPORARYFICTION from '@/components/lovewomenscontemporaryfiction'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/alsobypatriciadixon",
 			"name" : "alsobypatriciadixon",
 			"component" : ALSOBYPATRICIADIXON
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/epigraph",
 			"name" : "epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/nomoreyesterdays",
 			"name" : "nomoreyesterdays",
 			"component" : NOMOREYESTERDAYS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js